import styled from "styled-components";

import {
  BUTTON_SIZE,
  COLORS,
  FONT_SIZE,
  FONT_WEIGHT,
  SMALL_BUTTON_SIZE,
} from "../../../constants/Styles";
import { ButtonVariants } from "./constants";

const Button = styled.button<{
  buttonVariant: ButtonVariants;
  centerText?: boolean;
  hasLeftIcon?: boolean;
  isSmallSize?: boolean;
  disabledVariant?: boolean;
  isLoading?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: ${BUTTON_SIZE};
  background-color: ${COLORS.primary};
  color: ${COLORS.secondary};
  border-radius: 100px;
  padding: 0.5rem 1rem;
  white-space: nowrap;
  font-weight: ${FONT_WEIGHT.weight500};

  &:hover {
    background-color: ${COLORS.altPrimary};
    color: ${COLORS.secondary};

    img {
      filter: brightness(150%);
    }
  }

  ${({ centerText }) => centerText && `justify-content: center;`}

  ${({ centerText, hasLeftIcon }) =>
    !centerText && hasLeftIcon && `padding: .5rem 1rem .5rem .5rem;`}

  ${({ isSmallSize }) =>
    isSmallSize &&
    `
      height: ${SMALL_BUTTON_SIZE};
      
      > span {
        font-size: ${FONT_SIZE.size14};
      }
  `}

  ${({ buttonVariant }) =>
    buttonVariant == ButtonVariants.SECONDARY &&
    `
      background-color: ${COLORS.darkGray};
      color: ${COLORS.secondaryLight};
      
      &:hover {
        background-color: ${COLORS.altSecondary};
      }
  `}
  
  ${({ isLoading }) => isLoading && `background-color: ${COLORS.altPrimary};`}

  ${({ disabledVariant }) =>
    disabledVariant &&
    `
      background: linear-gradient(0deg, rgba(160, 160, 160, 0.50) 0%, rgba(160, 160, 160, 0.50) 100%), ${COLORS.inputGray};
      color: ${COLORS.darkGray};
      pointer-events: none;
      img {
        filter: brightness(-100%);
        opacity: 0.65;
      }
  `}
`;

const IconContainer = styled.div<{ isRightIcon?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5rem;

  ${({ isRightIcon }) => isRightIcon && `margin-left: 0.5rem;`}
`;

export { Button, IconContainer };
